import { render, staticRenderFns } from "./VehicleModelCUDialog.vue?vue&type=template&id=2bb33296"
import script from "./VehicleModelCUDialog.vue?vue&type=script&lang=js"
export * from "./VehicleModelCUDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports